import React, { useCallback, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { socket } from "../component/soket";
import ReCAPTCHA from "react-google-recaptcha";
import useStore from "../store";
import StartScreen from "../component/StartScreen";
import strings from "../lang/Localiz";
import HudEndGame from "../component/HudEndGame";
import LoaderFab from "../utils/Loader";

function Login() {
  const status = useStore((state) => state.soon);
  const [size, setSize] = useState(300)
  const gameOver = useStore((state) => state.gameOver);
  const lang = useStore((state) => state.lang);
  const modalEndGame = useStore((state) => state.modalEndGame);
  const getUser = useStore((state) => state.getUser);
  const [info, setInfo] = useState(false);
  const [paramToEnter, setParamToEnter] = useState([]);
  const [twoFA, setTwoFA] = useState(false);
  const [recap, setRecap] = useState(true);
  const [download, setDownload] = useState(false);

  useEffect(() => {
    socket.on("login", (data) => {
      if (data.error) {
        if (data.error === "ERROR_LOGIN_TFA_REQUIRED") {
          setTwoFA(true);
        } else {
          setInfo(data.error);
        }
        setDownload(false);
      } else if (data.soon) {
      } else if (data.endgame === true) {
        modalEndGame(data);
      } else {
        getUser(data);
      }
    });

    return () => {
      socket.off("login");
    };
  }, []);

  const {
    register,
    handleSubmit,
    formState: { isDirty, dirtyFields },
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
    },
  });
  const recaptchaRef = useRef();
  const recaptchaRef2 = useRef();
  const onSubmit = async (data, e) => {
    if (!(recaptchaRef.current.getValue() === "")) {
      const sendData = {
        username: data.username,
        password: data.password,
        recaptcha: recaptchaRef.current.getValue(),
      };
      setParamToEnter(sendData);
      socket.emit("login", sendData);
      e.target.reset(); // reset after form submit
      recaptchaRef.current.reset();
      setDownload(true);
      setRecap(true);
      setInfo(false);
    } else {
      setInfo("ERROR_NO_CAPTCHA");
    }
  };

  function onChange(value) {
    if (value) {
      setRecap(false);
    }
  }

  const handleChangeData = (e) => {
    e.preventDefault();
    const data = { ...paramToEnter };
    data[e.target.name] = e.target.value;
    setParamToEnter(data);
  };

  const handleUpdateData = (e) => {
    e.preventDefault();
    if (!(recaptchaRef2.current.getValue() === "")) {
      const data = { ...paramToEnter };
      const sendData = {
        username: data.username,
        password: data.password,
        tfa: data.code,
        recaptcha: recaptchaRef2.current.getValue(),
      };
      socket.emit("login", sendData);
      data.code = "";
      setParamToEnter(data);
      recaptchaRef2.current.reset();
      setDownload(true);
      setRecap(true);
    } else {
      setInfo("ERROR_NO_CAPTCHA");
    }
  };

  
  const handleRect = useCallback(node => {
    setSize(node?.getBoundingClientRect().width)
    node && resizeObserver(node)
  })

  React.useEffect(() => {
    if (recaptchaRef.current) recaptchaResize(recaptchaRef.current.captcha, size)
    if (recaptchaRef2.current) recaptchaResize(recaptchaRef2.current.captcha, size)
  }, [size])

  const resizeObserver = (form) => {
    const resizeObs = new ResizeObserver(() => {
      setSize(form.getBoundingClientRect().width)
    })
    resizeObs.observe(form)
  }

  const recaptchaResize = (recaptcha, containerWidth) => {
    if (window.innerWidth > 1000) {
      recaptcha.style.transform = `scale(1)`
      recaptcha.style.height = `unset`
      return
    }
    const reCaptchaWidth = 345;
    const captchaScale = containerWidth / reCaptchaWidth
    recaptcha.style.transform = `scale(${captchaScale})`
    recaptcha.style.height = `${60 * captchaScale}px`
  }


  return (
    <>
      <div className={"login-start"}>
        <StartScreen />

        {status === false && gameOver === false && (
          <>
            {!twoFA && (
              <div className={"form-login"} ref={handleRect}>
                <div className={"login-title"}>{strings.login.title}</div>

                {!download && (
                  <form className="auth-form" onSubmit={handleSubmit(onSubmit)}>
                    <div className="login-desc">{strings.login.nickname}</div>
                    <input
                      className={"input-login"}
                      required={true}
                      name="username"
                      {...register("username")}
                    />
                    <div className="login-desc">{strings.login.password}</div>
                    <input
                      required={true}
                      className={"input-login"}
                      type="password"
                      name="password"
                      {...register("password")}
                    />

                    <div className={"second-block-login"}>
                      <ReCAPTCHA
                        key={lang}
                        onChange={onChange}
                        hl={lang}
                        theme="dark"
                        className="recap"
                        ref={recaptchaRef}
                        sitekey="6LfNI_srAAAAACptxRSLfhdOMuyZuYJq1d5khles"
                      />
                      <button
                        disabled={
                          !(dirtyFields.username && dirtyFields.password) ||
                          recap
                        }
                        type="submit"
                      >
                        {strings.login.loginButton}
                      </button>
                    </div>
                    {info && (
                      <div className={"info-login-auth"}>
                        {info === "ERROR_NO_CAPTCHA" && strings.wrongCaptchaError}
                        {info === "ERROR_LOGIN" && strings.loginError}
                        {info === "ERROR_LOGIN_USER" && strings.loginError}
                      </div>
                    )}
                  </form>
                )}
                {download && <LoaderFab />}
              </div>
            )}
            {twoFA && (
              <div className={"form-login"}>
                <div className={"login-title"}>{strings.twoFactor}</div>
                {!download && (
                  <>
                    <div className={"login-2fa-desc"}>
                      {strings.twoFactorEnabled}
                    </div>

                    <form className="auth-form" onSubmit={handleUpdateData}>
                      <div className="login-desc">
                        {strings.code2FA}
                      </div>
                      <input
                        type="text"
                        className={"input-login"}
                        name="code"
                        onChange={(e) => handleChangeData(e)}
                      />

                      <div className={"second-block-login"}>
                        <ReCAPTCHA
                          onChange={onChange}
                          key={lang}
                          hl={lang}
                          theme="dark"
                          className="recap"
                          ref={recaptchaRef2}
                          sitekey="6LfNI_srAAAAACptxRSLfhdOMuyZuYJq1d5khles"
                        />

                        <button
                          disabled={paramToEnter.code === "" || recap}
                          type="submit"
                        >
                          {strings.login.accept}
                        </button>
                      </div>
                      {info && (
                        <div className={"info-login-auth"}>
                          {info === "ERROR_LOGIN_TFA" && strings.wrong2FAError}
                          {info === "ERROR_NO_CAPTCHA" && strings.wrongCaptchaError}
                        </div>
                      )}
                    </form>
                  </>
                )}
                {download && <LoaderFab />}
              </div>
            )}
          </>
        )}

        {status === true && (
          <div className={"form-login soon-bg"}>
            <div className={"soon-txt"}>{strings.soon}</div>
          </div>
        )}
        {gameOver === true && <HudEndGame />}
      </div>
    </>
  );
}

export default Login;
